(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collector-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.collector-reviews').forEach((section) => {
    const openButton = section.querySelector('.collector-reviews__review-button');
    const dialog = section.querySelector('.collector-reviews__dialog');
    const closeButton = section.querySelector('.collector-reviews__dialog-close');

    if (!openButton || !dialog || !closeButton) return;

    openButton.addEventListener('click', () => dialog.showModal());
    closeButton.addEventListener('click', () => dialog.close());

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    const successDialog = section.querySelector('.collector-reviews__success-dialog');
    const successClose = section.querySelector('.collector-reviews__success-close');
    const successDone = section.querySelector('.collector-reviews__success-done');

    if (successDialog) {
      requestAnimationFrame(() => successDialog.showModal());
      successClose?.addEventListener('click', () => successDialog.close());
      successDone?.addEventListener('click', () => successDialog.close());
      successDialog.addEventListener('click', (event) => {
        if (event.target === successDialog) successDialog.close();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
